import { gql } from "@apollo/client";

const SIGN_UP = gql`
mutation($email: String!, $documentNumber: String, $password: String!) {
  signUp(email: $email, documentNumber: $documentNumber, password: $password)
}
`;

export default SIGN_UP;